module.exports = __webpack_public_path__ + "img/IMG_2368_L_Wood_MockedUp.cd6eabd7.jpg";